module.exports = __webpack_public_path__ + "static/img/xsl.a617acf1.png";